/**
 * Italian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const it: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Cruscotto',
  'nav.funds': 'Fondi',
  'nav.investments': 'Investimenti',
  'nav.investees': 'Partecipate',
  'nav.esg': 'ESG Revisione',
  'nav.compliance': 'Conformità',
  'nav.reports': 'Report',
  'nav.settings': 'Impostazioni',
  'nav.users': 'Utenti',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Indicatori',
  'nav.taxonomy': 'Tassonomia UE',
  'nav.filings': 'Segnalazioni',
  'nav.calendar': 'Calendario',
  'nav.submit': 'Invia dati',
  'nav.submissions': 'Le mie sottomissioni',
  'nav.benchmarks': 'Benchmark',
  'nav.messages': 'Messaggi',
  'nav.portfolio': 'Portafoglio',
  'nav.performance': 'Performance dei fondi',
  'nav.esgSummary': 'ESG Riepilogo',
  'nav.pipeline': 'Pipeline',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Metriche di impatto',
  'nav.sdg': 'Mappatura OSS',
  'nav.audit': 'Traccia di audit',
  'nav.snapshots': 'Snapshot dei dati',
  'nav.knowledgeGraph': 'Grafo della conoscenza',
  'nav.geographic': 'Geografico',
  'nav.bi': 'BI Studio',
  'nav.ai': 'Assistente AI',
  'nav.tasks': 'Attività',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monitor normativo',

  // Common Actions
  'action.create': 'Crea',
  'action.edit': 'Modifica',
  'action.delete': 'Elimina',
  'action.save': 'Salva',
  'action.cancel': 'Annulla',
  'action.submit': 'Invia',
  'action.approve': 'Approva',
  'action.reject': 'Rifiuta',
  'action.download': 'Scarica',
  'action.export': 'Esporta',
  'action.import': 'Importa',
  'action.filter': 'Filtra',
  'action.search': 'Cerca',
  'action.refresh': 'Aggiorna',
  'action.close': 'Chiudi',
  'action.back': 'Indietro',
  'action.next': 'Avanti',
  'action.previous': 'Precedente',
  'action.viewAll': 'Visualizza tutto',
  'action.viewDetails': 'Visualizza dettagli',
  'action.generate': 'Genera',
  'action.signOut': 'Esci',
  'action.addNew': 'Aggiungi nuovo',
  'action.invite': 'Invita',

  // Statuses
  'status.draft': 'Bozza',
  'status.submitted': 'Inviato',
  'status.validated': 'Validato',
  'status.approved': 'Approvato',
  'status.rejected': 'Rifiutato',
  'status.pending': 'In attesa',
  'status.inProgress': 'In corso',
  'status.overdue': 'In ritardo',
  'status.compliant': 'Conforme',
  'status.filed': 'Depositato',
  'status.active': 'Attivo',
  'status.inactive': 'Inattivo',
  'status.closed': 'Chiuso',
  'status.fundraising': 'Raccolta fondi',
  'status.investing': 'Investimento',
  'status.harvesting': 'Raccolta',
  'status.validating': 'In validazione',
  'status.review': 'In revisione',
  'status.monitoring': 'Monitoraggio',
  'status.exiting': 'Uscita',
  'status.pipeline': 'Pipeline',
  'status.due_diligence': 'Due Diligence',
  'status.disbursed': 'Erogato',
  'status.restructured': 'Ristrutturato',
  'status.matured': 'Scaduto',
  'status.written_off': 'Cancellato',
  'status.exited': 'Uscito',
  'status.incomplete': 'Incompleto',
  'status.open': 'Aperto',
  'status.in_progress': 'In corso',
  'status.completed': 'Completato',
  'status.cancelled': 'Annullato',
  'status.accepted': 'Accettato',
  'status.failed': 'Fallito',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Panoramica del portafoglio',
  'dashboard.complianceStatus': 'Stato di conformità',
  'dashboard.collectionProgress': 'Progresso della raccolta',
  'dashboard.activityFeed': 'Attività',
  'dashboard.quickActions': 'Azioni rapide',
  'dashboard.investmentPipeline': 'Pipeline di investimento',
  'dashboard.totalFunds': 'Totale fondi',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Investimenti attivi',
  'dashboard.totalInvestees': 'Partecipate',
  'dashboard.recentActivity': 'Attività recente',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Totale impegnato',
  'lp.capitalCalled': 'Capitale richiamato',
  'lp.distributed': 'Distribuito',
  'lp.netPosition': 'Posizione netta',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Performance dei fondi',
  'lp.esgSummary': 'ESG Riepilogo',
  'lp.reportLibrary': 'Libreria report',
  'lp.taxonomyAligned': 'Allineato alla tassonomia',
  'lp.paiCoverage': 'PAI Copertura',
  'lp.portfolioPerformance': 'Performance portafoglio LP',

  // Fund Labels
  'fund.name': 'Nome del fondo',
  'fund.code': 'Codice del fondo',
  'fund.vintage': 'Anno di costituzione',
  'fund.size': 'Dimensione del fondo',
  'fund.targetSize': 'Dimensione target',
  'fund.currency': 'Valuta',
  'fund.strategy': 'Strategia',
  'fund.status': 'Stato',
  'fund.sfdrCategory': 'SFDR Categoria',
  'fund.geographyFocus': 'Focus geografico',
  'fund.sectorFocus': 'Focus settoriale',

  // Form Labels
  'form.name': 'Nome',
  'form.email': 'E-mail',
  'form.country': 'Paese',
  'form.amount': 'Importo',
  'form.currency': 'Valuta',
  'form.date': 'Data',
  'form.description': 'Descrizione',
  'form.notes': 'Note',
  'form.type': 'Tipo',
  'form.period': 'Periodo',
  'form.year': 'Anno',
  'form.required': 'Obbligatorio',
  'form.optional': 'Facoltativo',

  // Table Headers
  'table.fund': 'Fondo',
  'table.commitment': 'Impegno',
  'table.called': 'Richiamato',
  'table.distributed': 'Distribuito',
  'table.tvpi': 'TVPI',
  'table.status': 'Stato',
  'table.regulation': 'Regolamento',
  'table.filingType': 'Tipo di segnalazione',
  'table.reportingPeriod': 'Periodo',
  'table.createdAt': 'Creato',
  'table.actions': 'Azioni',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Tassonomia UE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Completezza dei dati',
  'compliance.nextDeadline': 'Prossima scadenza',

  // Reports
  'report.quarterly': 'Report trimestrale',
  'report.annual': 'Report annuale',
  'report.paiStatement': 'PAI Dichiarazione',
  'report.taxonomyReport': 'Report tassonomia',
  'report.generatedAt': 'Generato',
  'report.version': 'Versione',

  // General
  'general.loading': 'Caricamento...',
  'general.noData': 'Nessun dato disponibile',
  'general.error': 'Si è verificato un errore',
  'general.retry': 'Riprova',
  'general.total': 'Totale',
  'general.page': 'Pagina',
  'general.of': 'di',
  'general.showing': 'Visualizzazione',
  'general.results': 'risultati',
  'general.language': 'Lingua',
  'general.english': 'Inglese',
  'general.french': 'Francese',

  // Tour
  'tour.takeTour': 'Fai il tour',
  'tour.skip': 'Salta',
  'tour.next': 'Avanti',
  'tour.prev': 'Indietro',
  'tour.finish': 'Fine',


  // Tour Content, Form Labels, Table Headers, Actions, Errors (i18n wiring)
  'tour.sidebarTitle': 'Navigazione',
  'tour.sidebarContent': 'Usa la barra laterale per navigare tra gestione del portafoglio, raccolta dati ESG, conformità, report e strumenti di intelligence.',
  'tour.kpisTitle': 'Panoramica del portafoglio',
  'tour.kpisContent': 'Queste schede mostrano il tuo portafoglio a colpo d\'occhio — fondi totali, AUM, investimenti attivi e numero di partecipate.',
  'tour.actionsTitle': 'Azioni rapide',
  'tour.actionsContent': 'Crea fondi, aggiungi investimenti, invita partecipate e genera report con un clic.',
  'tour.languageTitle': 'Lingua',
  'tour.languageContent': 'Passa tra 24 lingue ufficiali dell\'UE. L\'intera interfaccia si traduce istantaneamente.',
  'tour.aiTitle': 'Assistente AI',
  'tour.aiContent': 'Fai domande sul tuo portafoglio in qualsiasi momento. L\'assistente AI ha il contesto completo sui tuoi fondi e investimenti.',
  'action.createFund': 'Crea fondo',
  'action.editFund': 'Modifica fondo',
  'action.addInvestment': 'Aggiungi investimento',
  'action.addInvestee': 'Aggiungi partecipata',
  'action.editInvestee': 'Modifica partecipata',
  'action.createTemplate': 'Crea modello',
  'action.createSubmission': 'Crea sottomissione',
  'action.createFiling': 'Crea segnalazione',
  'action.generateReport': 'Genera report',
  'action.inviteUser': 'Invita utente',
  'action.sendInvitation': 'Invia invito',
  'action.saveChanges': 'Salva modifiche',
  'form.fundName': 'Nome del fondo',
  'form.fundCode': 'Codice del fondo',
  'form.sfdrCategory': 'Categoria SFDR',
  'form.baseCurrency': 'Valuta di base',
  'form.targetSize': 'Dimensione target',
  'form.vintageYear': 'Anno di costituzione',
  'form.geographyFocus': 'Focus geografico',
  'form.sectorFocus': 'Focus settoriale',
  'form.investmentCode': 'Codice investimento',
  'form.instrumentType': 'Tipo di strumento',
  'form.maturityDate': 'Data di scadenza',
  'form.sector': 'Settore',
  'form.countryCode': 'Codice paese',
  'form.entityType': 'Tipo di entità',
  'form.region': 'Regione',
  'form.staffCount': 'Numero dipendenti',
  'form.borrowers': 'Mutuatari',
  'form.contactName': 'Nome contatto',
  'form.contactEmail': 'E-mail contatto',
  'form.templateName': 'Nome del modello',
  'form.templateType': 'Tipo di modello',
  'form.indicators': 'Indicatori',
  'form.reportingPeriod': 'Periodo di reporting',
  'form.reportingYear': 'Anno di reporting',
  'form.regulation': 'Regolamento',
  'form.filingType': 'Tipo di segnalazione',
  'form.reportType': 'Tipo di report',
  'form.emailAddress': 'Indirizzo e-mail',
  'form.role': 'Ruolo',
  'form.selectFund': 'Seleziona fondo...',
  'form.selectInvestee': 'Seleziona partecipata...',
  'table.code': 'Codice',
  'table.investee': 'Partecipata',
  'table.instrument': 'Strumento',
  'table.amount': 'Importo',
  'table.currency': 'Valuta',
  'table.maturity': 'Scadenza',
  'table.name': 'Nome',
  'table.country': 'Paese',
  'table.type': 'Tipo',
  'table.period': 'Periodo',
  'table.completion': 'Completamento',
  'table.submitted': 'Inviato',
  'table.version': 'Versione',
  'table.indicators': 'Indicatori',
  'table.dueDate': 'Data di scadenza',
  'table.generated': 'Generato',
  'table.email': 'E-mail',
  'table.role': 'Ruolo',
  'error.createFailed': 'Creazione fallita. Riprova.',
  'error.updateFailed': 'Aggiornamento fallito. Riprova.',
  'error.loadFailed': 'Caricamento dati fallito.',

  // Sidebar Sections
  'sections.portfolio': 'PORTAFOGLIO',
  'sections.dataCollection': 'RACCOLTA DATI',
  'sections.intelligence': 'INTELLIGENCE',
  'sections.ecosystem': 'ECOSISTEMA',
  'sections.admin': 'AMMINISTRAZIONE',
  'sections.other': 'ALTRO',

  // Page Titles
  'pages.messagesTitle': 'Messaggi',
  'pages.taxonomyTitle': 'Tassonomia UE',
  'pages.biStudioTitle': 'BI Studio',
  'pages.knowledgeGraphTitle': 'Grafo della Conoscenza',
  'pages.benchmarksTitle': 'Benchmark',
  'pages.mcpTitle': 'Integrazione MCP',
  'pages.tasksTitle': 'Attività',
  'pages.submitDataTitle': 'Invia dati ESG',

  // Empty States
  'empty.benchmarksComingSoon': 'Benchmark in arrivo',

  // Labels
  'labels.sfdr': 'SFDR',
  'labels.euTaxonomy': 'Tassonomia UE',
  'labels.csrd': 'CSRD',
  'labels.mifid': 'MiFID',
  'labels.other': 'Altro',
  'labels.critical': 'Critico',
  'labels.high': 'Alto',
  'labels.medium': 'Medio',
  'labels.low': 'Basso',

  // Count / summary strings
  'count.fundsTotal': '{count} fund(s) total',
  'count.investmentsTotal': '{count} investment(s) total',
  'count.investeesTotal': '{count} investee(s) total',

  // Filter options
  'filter.allStatus': 'All Status',
  'filter.allSfdr': 'All SFDR',

  // Empty states
  'empty.noFundsYet': 'No funds yet. Create your first fund.',
  'empty.noFundsMatch': 'No funds match your filters.',
  'empty.noInvestmentsYet': 'No investments yet.',
  'empty.noInvestmentsMatch': 'No investments match your search.',
  'empty.noInvesteesYet': 'No investees yet.',
  'empty.noInvesteesMatch': 'No investees match your search.',
  'empty.noTemplatesYet': 'No ESG templates configured yet.',
  'empty.noSubmissionsYet': 'No ESG submissions yet.',
  'empty.noComplianceData': 'No SFDR compliance data available.',
  'empty.noFilingsYet': 'No compliance filings yet.',
  'empty.noReportsYet': 'No reports generated yet.',
  'empty.selectFundPai': 'Select a fund to view PAI indicators.',
  'empty.noPaiIndicators': 'No PAI indicators found for this fund.',
  'empty.selectFundCalendar': 'Select a fund to view compliance calendar.',
  'empty.noCalendarEvents': 'No upcoming events for this fund.',

  // Page subtitles
  'subtitle.esg': 'Templates and data submissions',
  'subtitle.compliance': 'SFDR, PAI indicators, and regulatory filings',
  'subtitle.reports': 'Generate and manage compliance reports',
  'subtitle.settings': 'Manage your account and preferences',

  // Tab labels
  'tab.templates': 'Templates',
  'tab.submissions': 'Submissions',
  'tab.sfdr': 'SFDR',
  'tab.paiIndicators': 'PAI Indicators',
  'tab.filings': 'Filings',
  'tab.reports': 'Reports',
  'tab.calendar': 'Calendar',

  // Compliance table headers
  'table.indicator': 'Indicator',
  'table.category': 'Category',
  'table.metric': 'Metric',
  'table.value': 'Value',
  'table.mandatory': 'Mandatory',
  'table.data': 'Data',
  'table.deadline': 'Deadline',
  'table.taxonomy': 'Taxonomy',

  // Yes/No
  'general.yes': 'Yes',
  'general.no': 'No',

  // Error messages
  'error.loadTemplates': 'Failed to load templates.',
  'error.loadSubmissions': 'Failed to load submissions.',
  'error.loadCompliance': 'Failed to load compliance data.',
  'error.loadPai': 'Failed to load PAI indicators.',
  'error.loadFilings': 'Failed to load filings.',
  'error.loadCalendar': 'Failed to load calendar events.',
  'error.createTemplate': 'Failed to create template. Please try again.',
  'error.createSubmission': 'Failed to create submission. Please try again.',
  'error.createFiling': 'Failed to create filing. Please try again.',
  'error.generateReport': 'Failed to generate report.',
  'error.templateNameRequired': 'Template name is required',
  'error.selectFund': 'Select a fund',
  'error.selectInvestee': 'Select an investee',
  'error.validAmount': 'Enter a valid amount',
  'error.reportingPeriodRequired': 'Reporting period is required',
  'error.validYearRequired': 'Valid year is required',
  'error.enterPeriod': 'Enter a period',
  'error.nameRequired': 'Name is required',
  'error.countryCodeRequired': 'Country code is required',
  'error.operationFailed': 'Operation failed.',
  'error.pleaseselectFund': 'Please select a fund',

  // Success messages
  'success.submissionCreated': 'Submission created successfully.',
  'success.profileSaved': 'Profile saved successfully.',

  // Relative time
  'time.justNow': 'Just now',
  'time.minutesAgo': '{count}m ago',
  'time.hoursAgo': '{count}h ago',
  'time.daysAgo': '{count}d ago',

  // Settings
  'settings.profile': 'Profile',
  'settings.organization': 'Organization',
  'settings.apiKeys': 'API Keys',
  'settings.notifications': 'Notifications',
  'settings.orgId': 'Org ID',
  'settings.tier': 'Tier',
  'settings.apiKeysDescription': 'Contact your organization administrator to manage API keys and integration credentials.',
  'settings.apiKeysNote': 'API keys provide programmatic access to Impact Core data. For security, key creation and revocation is restricted to organization admins.',
  'settings.notifReportAlerts': 'Report generation alerts',
  'settings.notifReportAlertsDesc': 'Email when a report is generated or fails',
  'settings.notifComplianceReminders': 'Compliance deadline reminders',
  'settings.notifComplianceRemindersDesc': 'Email reminders for upcoming filing deadlines',
  'settings.notifEsgUpdates': 'ESG submission updates',
  'settings.notifEsgUpdatesDesc': 'Email when investee submissions change status',
  'settings.notifInAppActivity': 'In-app activity feed',
  'settings.notifInAppActivityDesc': 'Show real-time activity notifications in header',

  // Data Completeness label
  'compliance.dataCompletenessLabel': 'Data Completeness',
};
